/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['div.table[_ngcontent-%COMP%]{max-height:420px;overflow:auto}thead[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{position:sticky;position:-webkit-sticky;top:0;background-color:#fff}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvamVua2lucy93b3Jrc3BhY2UvcHJvZHVjdGlvbi1hcmdvcy1mcm9udC9hcmdvcy9zcmMvYXBwL2RpYWdub3Npcy9jb21wb25lbnQvY29vcmRpbmF0ZXMtZGlzcGxheS9jb29yZGluYXRlcy1kaXNwbGF5LmNvbXBvbmVudC5jc3Muc2hpbS5uZ3N0eWxlLnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vaG9tZS9qZW5raW5zL3dvcmtzcGFjZS9wcm9kdWN0aW9uLWFyZ29zLWZyb250L2FyZ29zL3NyYy9hcHAvZGlhZ25vc2lzL2NvbXBvbmVudC9jb29yZGluYXRlcy1kaXNwbGF5L2Nvb3JkaW5hdGVzLWRpc3BsYXkuY29tcG9uZW50LmNzcyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/$$_gendir/app/diagnosis/component/coordinates-display/coordinates-display.component.css.shim.ngstyle.ts